// context/DarkModeContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { getDarkMode, changeDarkMode } from "../apiHandles/user_progress";

const DarkModeContext = createContext();

export const DarkModeProvider = ({ children }) => {
    const [darkMode, setDarkMode] = useState(() => {
        return localStorage.getItem('darkMode') === 'true';
    });
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchDarkMode = async () => {
            // Check if user is authenticated before making API call
            const accessToken = localStorage.getItem("access");
            const refreshToken = localStorage.getItem("refresh");

            // If user is not logged in, just use localStorage value and don't call API
            if (!accessToken && !refreshToken) {
                setIsLoading(false);
                return;
            }

            try {
                const serverDarkMode = await getDarkMode();
                setDarkMode(serverDarkMode);
                localStorage.setItem('darkMode', serverDarkMode.toString());
            } catch (error) {
                console.error("Error fetching dark mode:", error);
                // If error is due to authentication, just use localStorage value
                // Don't show alerts for unauthenticated users
            } finally {
                setIsLoading(false);
            }
        };
        fetchDarkMode();
    }, []);

    const toggleDarkMode = async () => {
        try {
            const newValue = !darkMode;
            setDarkMode(newValue);
            localStorage.setItem('darkMode', newValue.toString());
            await changeDarkMode();
        } catch (error) {
            console.error("Error toggling dark mode:", error);
            // Rollback on error
            setDarkMode(!darkMode);
        }
    };

    return (
        <DarkModeContext.Provider value={{ darkMode, toggleDarkMode, isLoading }}>
            {children}
        </DarkModeContext.Provider>
    );
};

export const useDarkMode = () => {
    const context = useContext(DarkModeContext);
    if (!context) {
        throw new Error("useDarkMode must be used within DarkModeProvider");
    }
    return context;
};